import React from 'react';
import { builderStyles } from '../builder/primitives';

/** A compact label/value grid for the leaf detail panels. */
export const DefinitionList: React.FC<{ items: Array<[string, React.ReactNode]> }> = ({ items }) => (
  <dl
    style={{
      display: 'grid',
      gridTemplateColumns: 'max-content 1fr',
      columnGap: 16,
      rowGap: 6,
      margin: 0,
      fontSize: 13,
    }}
  >
    {items.map(([label, value]) => (
      <React.Fragment key={label}>
        <dt style={{ opacity: 0.6 }}>{label}</dt>
        <dd style={{ margin: 0 }}>{value}</dd>
      </React.Fragment>
    ))}
  </dl>
);

/** Muted inline note — used for loading, empty, and error states inside a drill-down body. */
export const Note: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className={builderStyles.lead} style={{ margin: '8px 0' }}>
    {children}
  </p>
);

/** A small titled sub-panel inside a detail body. */
export const SubPanel: React.FC<{ title: string; count?: number; children: React.ReactNode }> = ({
  title,
  count,
  children,
}) => (
  <section style={{ marginTop: 14 }}>
    <h5 style={{ margin: '0 0 8px', fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5, opacity: 0.7 }}>
      {title}
      {count != null && <span style={{ opacity: 0.6 }}> ({count})</span>}
    </h5>
    {children}
  </section>
);
